import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import * as React from 'react';

export function SvgMoreHoriz() {
  return <ShowMoreHorizontalIcon label="" testId="ads-refreshed-icon" />;
}
